import { render } from "./WBPayButton.vue?vue&type=template&id=b9dd3d1e&ts=true"
import script from "./WBPayButton.vue?vue&type=script&lang=ts"
export * from "./WBPayButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__